export const CONFIRMATION_DIALOG__RESET_FILE = 'CONFIRMATION_DIALOG__RESET_FILE';
